import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alert-body__content__table" }
const _hoisted_2 = { class: "alert-body__content__table--head alert-body__content__table--head--arrival" }
const _hoisted_3 = { class: "alert-body__content__table--head alert-body__content__table--head--order" }
const _hoisted_4 = { class: "alert-body__content__table--head alert-body__content__table--head--diff" }
const _hoisted_5 = { class: "alert-body__content__table--data alert-body__content__table--data--arrival" }
const _hoisted_6 = { class: "alert-body__content__table--data alert-body__content__table--data--order" }
const _hoisted_7 = { class: "alert-body__content__table--data alert-body__content__table--data--diff" }
const _hoisted_8 = { class: "alert-body__content__table" }
const _hoisted_9 = { class: "alert-body__content__table--head alert-body__content__table--head--arrival" }
const _hoisted_10 = { class: "alert-body__content__table--head alert-body__content__table--head--order" }
const _hoisted_11 = { class: "alert-body__content__table--head alert-body__content__table--head--diff" }
const _hoisted_12 = { class: "alert-body__content__table--data alert-body__content__table--data--arrival" }
const _hoisted_13 = { class: "alert-body__content__table--data alert-body__content__table--data--order" }
const _hoisted_14 = { class: "alert-body__content__table--data alert-body__content__table--data--diff" }

import { storeToRefs } from 'pinia';
import { i18n } from '@/i18n';
import { useInventoryStore } from '../../pages/useInventoryStore/';
import { InventoryAlertKinds, isInventoryAlertKinds } from '../../domains/entities/Alert';
import { IYearMonth } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { InventoryRepository } from '@/coreInfrastructureModule/Repositories/InventoryRepository';
import { IParentBusiness } from '@/InventoryControlModule/domains/entities/Business';
import AlertCell from '@/corePagesModule/components/table/AlertCell.vue';

// i18n

export default /*@__PURE__*/_defineComponent({
  __name: 'InventoryAlertCell',
  props: {
    propBusiness: {},
    propRelativeMonth: {}
  },
  setup(__props: any) {

const t = i18n.t;

// Store
const inventoryStore = useInventoryStore();
const { state } = storeToRefs(inventoryStore);
const { toggleOpenAlert, getTableAlertData, setupMoveWarehouse } = inventoryStore;

// Props



// Repository
const inventoryRepository = new InventoryRepository();

/**
 * アラートの追加情報を表示用に変換する処理
 * @param num1 - 基準となる数値
 * @param num2 - 比較対象の数値
 */
const convertAdditionalAlertDataForDisplay = (num1?: number, num2?: number) => {
  if (num2) {
    return ((num1 ?? 0) - num2).addComma();
  }
  return (num1 ?? 0).addComma();
};

/**
 * アラートの次へボタンをクリックしたときのイベント
 * @param alertKind - アラートの種類
 * @param business - 取引
 * @param monthDistance - 月の差分
 */
const onMoveWarehouseCheckButton = async (alertKind: string, business: IParentBusiness, monthDistance: number) => {
  if (!isInventoryAlertKinds(alertKind)) return;
  if (alertKind === InventoryAlertKinds.StorageMoved) {
    state.value.isOpeningAlertBusinessId = '';
    state.value.moveWarehouseModalState.isLoadingModalOpen = true;
    const targetYearMonth: IYearMonth = DateService.addMonthsToCurrentDate(monthDistance);
    await setupMoveWarehouse(inventoryRepository, business, targetYearMonth);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AlertCell, {
    "alert-data": _unref(getTableAlertData)(_ctx.propBusiness, _ctx.propRelativeMonth).map((data) => data.data),
    "prop-is-opening": _unref(state).isOpeningAlertBusinessId === _ctx.propBusiness.businessId,
    "icon-warning": "alertCellWarningOnInventoryControl",
    "icon-error": "alertCellErrorOnInventoryControl",
    onOnNext: _cache[0] || (_cache[0] = ($event: any) => (onMoveWarehouseCheckButton($event, _ctx.propBusiness, _ctx.propRelativeMonth))),
    onClick: _cache[1] || (_cache[1] = 
      (isOpening) => {
        _unref(toggleOpenAlert)(_ctx.propBusiness.businessId, isOpening);
      }
    )
  }, _createSlots({ _: 2 }, [
    (_unref(getTableAlertData)(_ctx.propBusiness, _ctx.propRelativeMonth, _unref(InventoryAlertKinds).ArrivalGreaterThanOrder).length === 1)
      ? {
          name: `alertBody-${_unref(InventoryAlertKinds).ArrivalGreaterThanOrder}`,
          fn: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getTableAlertData)(_ctx.propBusiness, _ctx.propRelativeMonth, _unref(InventoryAlertKinds).ArrivalGreaterThanOrder), (alertDetum, alertIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${_ctx.propBusiness.businessId}-alert-body-${_unref(InventoryAlertKinds).ArrivalGreaterThanOrder}-${alertIndex}`
              }, [
                _createTextVNode(_toDisplayString(`${_unref(t)('対象月')}: ${alertDetum.additionalData?.yearMonth.year}/${alertDetum.additionalData?.yearMonth.month}`) + " ", 1),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('入荷数量')), 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('発注数量')), 1),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('差分')), 1),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(convertAdditionalAlertDataForDisplay(alertDetum.additionalData?.arrivalAmount)), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(convertAdditionalAlertDataForDisplay(alertDetum.additionalData?.orderAmount)), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(convertAdditionalAlertDataForDisplay(alertDetum.additionalData?.arrivalAmount, alertDetum.additionalData?.orderAmount)), 1)
                ])
              ], 64))
            }), 128))
          ]),
          key: "0"
        }
      : undefined,
    (_unref(getTableAlertData)(_ctx.propBusiness, _ctx.propRelativeMonth, _unref(InventoryAlertKinds).OrderGreaterThanArrival).length === 1)
      ? {
          name: `alertBody-${_unref(InventoryAlertKinds).OrderGreaterThanArrival}`,
          fn: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getTableAlertData)(_ctx.propBusiness, _ctx.propRelativeMonth, _unref(InventoryAlertKinds).OrderGreaterThanArrival), (alertDetum, alertIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${_ctx.propBusiness.businessId}-alert-body-${_unref(InventoryAlertKinds).OrderGreaterThanArrival}-${alertIndex}`
              }, [
                _createTextVNode(_toDisplayString(`${_unref(t)('対象月')}: ${alertDetum.additionalData?.yearMonth.year}/${alertDetum.additionalData?.yearMonth.month}`) + " ", 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('入荷数量')), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('発注数量')), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('差分')), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(convertAdditionalAlertDataForDisplay(alertDetum.additionalData?.arrivalAmount)), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(convertAdditionalAlertDataForDisplay(alertDetum.additionalData?.orderAmount)), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(convertAdditionalAlertDataForDisplay(alertDetum.additionalData?.arrivalAmount, alertDetum.additionalData?.orderAmount)), 1)
                ])
              ], 64))
            }), 128))
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["alert-data", "prop-is-opening"]))
}
}

})